
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe, CommonModule } from '@angular/common';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/MPID-List-Columns.json';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { Subscription } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";

@Component({
    selector: 'app-mpid-list',
    imports: [FilterPanelComponent, GridComponent, CommonModule, MatProgressSpinner, QuickSearchComponent],
    templateUrl: './mpid-list.component.html',
    styleUrls: ['./mpid-list.component.scss']
})
export class MpidListComponent implements OnInit, OnDestroy {

    quickFilterArray: any = GridColumnsJSON["mpid-list-quick-search-fields"];
    GridColumns = GridColumnsJSON["mpid-list-grid-columns"];
    panelOpenState: boolean;
    dataset1: any[] = [];
    LastCATExecutionDate!: any[];
    DefaultFilterArray: any = [];
    isLoadingResults = true;
    Limit: any = { 'Start': '', 'End': '' };
    totalRecords: any;
    rowcount!: number;
    startLimit: any = 0;
    endLimit!: number;
    subscription!: Subscription;
    constructor(
      private gridService: GridService,
      private emitterService: EmitterService,
      private userServices: UserService,
      private datePipe: DatePipe) {
          this.panelOpenState = false;
    }

    ngOnInit(): void {
      this.rowcount = this.gridService.getGridRowsCount();
      this.Limit = { 'Start': '0', 'End': this.rowcount };
      this.totalRecords = this.rowcount;
      this.dataset1 = [];
      this.defaultFilter();
      this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
        if (value) {
          this.getData();
        }
      });
    }

    updateDefaultArray($event: any) {
      this.emitterService.isResetGridLimit.emit(true);
      this.DefaultFilterArray = $event;
      this.startLimit = 0;
      this.Limit.Start = 0;
      this.getData();
    }
  
    clearQuickSearch($event: any) {
      this.emitterService.isResetGridLimit.emit(true);
      this.DefaultFilterArray = $event;
      this.startLimit = 0;
      this.Limit.Start = 0;
      this.getData();
    }

    FilterApplyFilterEvent(event: any) {
      this.emitterService.isResetGridLimit.emit(true);
      this.DefaultFilterArray = [];
      this.DefaultFilterArray = event;
      this.startLimit = 0;
      this.Limit.Start = 0;
      this.getData();
    }

    GridChangeLimitEvent(event: any) {
      this.Limit = event;
      this.getData();
    }

    defaultFilter() {

      this.LastCATExecutionDate = [];
      this.LastCATExecutionDate.push(this.userServices.MPIDDate); // Fromdate
      this.LastCATExecutionDate.push(this.userServices.MPIDDate); // Todate


        this.DefaultFilterArray = [
          { 'isdefault':  'true', 'label': 'Date', 'columnname': 'Str_to_date', 'filterby': '', 'values':
          this.LastCATExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
          { 'isdefault':  'true', 'label': 'MPID', 'columnname': 'IMID', 'filterby': 'IS', 'values': '', 
          'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
          { 'isdefault':  'true', 'label': 'Firm Name', 'columnname': 'firmName', 'filterby': 'IS', 'values': '', 
          'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
          { 'isdefault':  'true', 'label': 'CRDID', 'columnname': 'CRDID', 'filterby': 'IS', 'values': '', 
          'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
        ];
      
      this.getData();
    }

    getData() {
      this.isLoadingResults = true;
      this.gridService.prepareData(APIURL.MPID_List, this.DefaultFilterArray, this.Limit, 'MPID-List')
        .subscribe({
          next: (Element:any) => {
          this.isLoadingResults = false;
          let dataset: any;
          dataset = Element;
          this.dataset1 = dataset.Data;
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        }, error: (err: HttpErrorResponse) => {
          this.dataset1 = [];
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.isLoadingResults = false;
        }});
    }
    ngOnDestroy() {
      if(this.subscription)
    this.subscription.unsubscribe();
    }
}
